export default "__VITE_ASSET__DWLBK$nU__"